const Card1 = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="scale-110"
    >
      <circle cx="28" cy="28" r="28" fill="white" />
      <path
        d="M27.4167 20.1667H25.3333C24.1875 20.1667 23.25 19.2292 23.25 18.0833C23.25 16.9375 24.1875 16 25.3333 16H27.4167C28.5625 16 29.5 16.9375 29.5 18.0833C29.5 19.2292 28.5625 20.1667 27.4167 20.1667ZM37.8333 25.375H33.6667C31.3646 25.375 29.5 27.2396 29.5 29.5417V36.8333C29.5 39.1354 31.3646 41 33.6667 41H37.8333C40.1354 41 42 39.1354 42 36.8333V29.5417C42 27.2396 40.1354 25.375 37.8333 25.375ZM37.8333 35.7917H33.6667C33.0938 35.7917 32.625 35.3229 32.625 34.75C32.625 34.1771 33.0938 33.7083 33.6667 33.7083H37.8333C38.4062 33.7083 38.875 34.1771 38.875 34.75C38.875 35.3229 38.4062 35.7917 37.8333 35.7917ZM37.8333 31.625H33.6667C33.0938 31.625 32.625 31.1562 32.625 30.5833C32.625 30.0104 33.0938 29.5417 33.6667 29.5417H37.8333C38.4062 29.5417 38.875 30.0104 38.875 30.5833C38.875 31.1562 38.4062 31.625 37.8333 31.625ZM33.6667 23.2917H35.75C35.75 20.7708 33.9479 18.6875 31.5729 18.2083C31.5 20.4479 29.6771 22.25 27.4167 22.25H25.3333C23.0729 22.25 21.2292 20.4375 21.1771 18.1875C18.8021 18.6667 17 20.7708 17 23.2917V35.7917C17 38.6667 19.3333 41 22.2083 41H29.0104C28.0208 39.8958 27.4167 38.4375 27.4167 36.8333V29.5417C27.4167 26.0938 30.2188 23.2917 33.6667 23.2917Z"
        fill="#009E3E"
      />
    </svg>
  );
};

export default Card1;
